<template>
  <v-container>
    <v-layout row wrap>
      <v-flex x12 md8 lg6>
        <div v-for="(paragraph, index) in details.paragraphs"  :key="index">
          <p v-if="paragraph.title !== ''">{{ paragraph.title }}</p>
          <p class="content-text">{{ paragraph.description }}</p>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    details: {
      required: true,
      type: Object,
      default: () => { return {} }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Design.vue